export const constants = {
    /** Production **/
     endPoint: "https://apiv2.soffront.com/",
     STATUS_FAILURE: '-1',

    /** Test Server **/
    //endPoint: "https://testapiv2vpc.soffront.com/",
    //STATUS_FAILURE: '-1',

    /** Local **/
    //endPoint: "http://localhost:9080/sfapi",
    //STATUS_FAILURE: '-1',
}